import { z } from 'zod/v4'

/** The shortest reason that explains a publication of content (after trimming). */
export const CHANGE_REASON_MIN = 10
export const CHANGE_REASON_MAX = 500

/**
 * The reason that goes with every publication of versioned content (translations: #4034; the rest of the content:
 * #4060). It is trimmed BEFORE it is measured, so nine characters surrounded by spaces are refused.
 *
 * The length counts CODE POINTS, like `char_length` in the database CHECK: zod's own `.min`/`.max` count UTF-16
 * units, so «Erratas 🐛» (9 code points, 10 units) would pass the contract and be refused by Postgres with a 500.
 * The unit bounds only keep a code point count from being asked of an unbounded string: every code point takes at
 * least one unit and at most two.
 */
export const changeReasonSchema = z
  .string()
  .trim()
  .min(CHANGE_REASON_MIN)
  .max(CHANGE_REASON_MAX * 2)
  .refine(
    (value) => {
      const length = [...value].length
      return length >= CHANGE_REASON_MIN && length <= CHANGE_REASON_MAX
    },
    {
      message: `The reason must have between ${CHANGE_REASON_MIN} and ${CHANGE_REASON_MAX} characters`,
    },
  )
